export default __webpack_public_path__ + "static/media/running2.9112c102.png";